import { createAction } from 'redux-actions'
import get from 'lodash.get'
import { parse } from 'qs'

import * as globalTypes from '../../actions/types'
import FileService from '../../services/FileService'
import FILE_TYPES from '../../utils/fileEnums'
import { loadPagination } from '../../utils/constants'
import { fetchLoadById } from '../LoadsDetails/actions'
import history from '../../history'
import { getChannels, startCentrifuge, centrifugeStatus } from '../../actions/centrifuge'
import LoadDetailsService from '../LoadsDetails/service'

import {
  sectionFiltersMap,
} from './utils'
import LoadsService from './service'
import * as types from './actionTypes'

export const fetchReceiversById = (hashId, deliveryId) => (
  (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
    LoadDetailsService
      .fetchReceivers(hashId, deliveryId)
      .then((result) => {
        dispatch(createAction(types.FETCH_RECEIVERS_BY_ID)(result))
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
      })
      .catch(() => dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)))
  }
)

export const requestAuctionTime = () => (
  (dispatch, state) => {
    let loadsIds = get(state(), 'loads.marketLoads', []) || []
    if (loadsIds.length) {
      loadsIds = loadsIds.filter(load =>
        (!load.status ?
          load
          && load.shippingStatus === 'WAIT_TRANSPORTER_ACCEPT'
          && load.shippingType.toLowerCase() === 'auction'
          : load
          && load.status === 'WAIT_TRANSPORTER_ACCEPT'
          && load.type.toLowerCase() === 'auction'),
      )
      // && load.status === 'WAIT_TRANSPORTER_ACCEPT'
      // && load.type.toLowerCase() === 'auction')
    }
    loadsIds = loadsIds.map(item => item.hashId)
    const path = get(history, 'location.pathname', '')
    if (path.includes('/details')) {
      const hash = path.substr(7, path.indexOf('/details') - 7)
      loadsIds = [hash]
    }
    LoadsService
      .requestAuctionTime(loadsIds)
      .then(() => {
      })
      .catch((err) => {
        console.log(err)
      })
  }
)
export const requestAuctionTimeCachedLoads = () => (
  (dispatch, state) => {
    let loadsIds = get(state(), 'newLoads.negotiation.list', []) || []
    if (loadsIds.length) {
      loadsIds = loadsIds.filter(load =>
        (!load.status ?
          load
          && load.shippingStatus === 'WAIT_TRANSPORTER_ACCEPT'
          && load.shippingType.toLowerCase() === 'auction'
          : load
          && load.status === 'WAIT_TRANSPORTER_ACCEPT'
          && load.type.toLowerCase() === 'auction'),
      )
      // && load.status === 'WAIT_TRANSPORTER_ACCEPT'
      // && load.type.toLowerCase() === 'auction')
    }
    loadsIds = loadsIds.map(item => item.hashId)
    const path = get(history, 'location.pathname', '')
    if (path.includes('/details')) {
      const hash = path.substr(7, path.indexOf('/details') - 7)
      loadsIds = [hash]
    }
    LoadsService
      .requestAuctionTime(loadsIds)
      .then(() => {
      })
      .catch((err) => {
        console.log(err)
      })
  }
)

export const subscribeLoadsCentrifuge = loads => (
  (dispatch) => {
    const filteredLoadsIds = loads
      .filter(load => (load.status === 'WAIT_TRANSPORTER_ACCEPT'))
      .map(item => item.hashId)
    if (filteredLoadsIds.length) {
      dispatch(getChannels())
    }
  }
)


export const fetchLoadsByParams = params => (
  (dispatch) => {
    const fullParams = {
      orderColumn: 'launchDate',
      orderDirection: 'DESC',
      page: 1,
      size: loadPagination,
      ...params,
    }
    if (params.fromFilter) {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
    }
    LoadsService
      .fetchLoadsByParams(fullParams)
      .then((result) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
        if (fullParams.page === 1) {
          switch (params.tab) {
            case 'market':
              dispatch(createAction(types.CLEAR_MARKET_LOADS)())
              break
            case 'my':
              dispatch(createAction(types.CLEAR_MY_LOADS)())
              break
            case 'locked':
              dispatch(createAction(types.CLEAR_LOCKED_LOADS)())
              break
            case 'review':
              dispatch(createAction(types.CLEAR_REVIEW_LOADS)())
              break
            default:
              dispatch(createAction(types.CLEAR_CLOSED_LOADS)())
              break
          }
        }
        if (result && result.shippings) {
          centrifugeStatus().then(
            async (res) => {
              if (res === 'connected') {
                dispatch(subscribeLoadsCentrifuge(result.shippings))
              } else {
                await dispatch(startCentrifuge(() => dispatch(subscribeLoadsCentrifuge(result.shippings))))
              }
            },
          )
          // dispatch(subscribeLoadsCentrifuge(result.shippings))
          dispatch(createAction(types.FETCH_LOAD_BY_PARAMS)(result.shippings))
        }
        if (result && result.info) {
          dispatch(createAction(types.FETCH_INFO_LOADS)(result.info))
        }

        switch (params.tab) {
          case 'market': {
            dispatch(createAction(types.FETCH_INFO_MARKET_LOADS)(result.info))
            return dispatch(createAction(types.FETCH_MARKET_LOADS)(
              result.shippings.filter(item => !item.hasMyAccept),
            ))
          }
          case 'my':
            dispatch(createAction(types.FETCH_INFO_MY_LOADS_LOADS)(result.info))
            return dispatch(createAction(types.FETCH_MY_LOADS)(result.shippings))
          case 'locked':
            dispatch(createAction(types.FETCH_INFO_LOCKED_LOADS)(result.info))
            return dispatch(createAction(types.FETCH_LOCKED_LOADS)(result.shippings))
          case 'review': {
            const reviews = result.shippings.filter(item => (item.acceptType === 'WAIT_DURATION' && item.hasMyAccept) || item.status === 'WAITING_APPROVE')
            dispatch(createAction(types.FETCH_INFO_REVIEW_LOADS)(result.info))
            return dispatch(createAction(types.FETCH_REVIEW_LOADS)(reviews))
          }
          default:
            dispatch(createAction(types.FETCH_INFO_CLOSED_LOADS)(result.info))
            return dispatch(createAction(types.FETCH_CLOSED_LOADS)(result.shippings))
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }
)


export const closeLoadByTransporter = (receiptPath, hashId, refreshLoads) => (
  (dispatch) => {
    LoadsService
      .markLoadAsDelivered(hashId, receiptPath)
      .then(() => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
        if (refreshLoads) {
          dispatch(fetchLoadsByParams({ tab: 'my' }))
        } else {
          dispatch(fetchLoadById(hashId))
        }
        return dispatch(createAction(globalTypes.SHOW_USER_FEEDBACK)({
          feedbackMessage: 'Comprovate enviado, entrega finalizada.',
          feedbackTitle: null,
          feedbackType: 'MESSAGE',
          styleFeedbackType: 'success',
          messageTimestamp: new Date().getTime(),
        }))
      })
      .catch((err) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
        console.log(err)
      })
  }
)

export const markLoadAsDelivered = (hashId, receiptFile, refreshLoads) => (
  (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true))
    FileService
      .upload(receiptFile, FILE_TYPES.shipping.receipt)
      .then((result) => {
        if (!result) {
          dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false))
          console.log('Erro ao salvar comprovante de entrega')
          return dispatch(createAction(globalTypes.SHOW_USER_FEEDBACK)({
            feedbackMessage: 'Comprovate não foi salvo.',
            feedbackTitle: null,
            feedbackType: 'MESSAGE',
            styleFeedbackType: 'error',
            messageTimestamp: new Date().getTime(),
          }))
        }
        return dispatch(closeLoadByTransporter(result, hashId, refreshLoads))
      })
  }
)


export const updateLoadListByStatus = () => (
  (dispatch) => {
    const queryString = get(history, 'location.search', '')
    const query = parse(queryString.replace('?', ''))
    const section = query.section || 'market'
    dispatch(fetchLoadsByParams(sectionFiltersMap[section]))
  }
)

